import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './login/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { RouteProvider } from './login/RouteContext'
import { ThemeProvider } from '@mui/material/styles';
import theme from './estilo/Theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <RouteProvider>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </RouteProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
